export const WebLogo = () => {
  return (
    <svg
      className=" max-sm:w-[65px] w-[90px] me-[11px]"
      width="105"
      height="59"
      viewBox="0 0 105 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3_73)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.0997 10.0655C62.4002 10.2644 65.5633 10.0257 67.946 10.0257C70.6161 10.0257 73.2453 9.98594 75.9154 9.98594C78.257 9.98594 85.6514 9.86659 87.7053 9.98594C91.2382 10.2246 91.7723 14.8794 91.2382 17.7439C90.8274 20.0116 89.8415 21.8019 88.3215 22.6373C87.2124 23.2341 79.4072 23.2341 77.1478 23.3137C75.8744 23.3534 74.2723 23.2341 73.122 23.3534C72.7112 23.8706 70.5751 27.6501 70.0821 28.5254C69.6302 29.2813 67.1654 33.3791 67.1244 33.8167L87.5821 33.8963C88.8967 33.8963 89.595 34.6124 90.088 35.4478C91.9366 38.6306 90.9096 46.1896 87.3767 47.3433C84.9941 47.8207 64.2488 47.5422 61.3321 47.582L61.5375 58.7614C67.5762 58.7614 75.4636 58.7614 81.1737 58.841C84.2957 58.9603 87.3767 59.0001 90.4988 58.9205C93.8673 58.841 95.757 58.9205 98.3039 57.3689C105.082 53.311 106.15 40.9779 102.535 33.578C102.289 33.021 102.001 32.5038 101.714 32.0662C101.426 31.549 101.015 31.0716 100.81 30.5942C100.974 30.2759 100.892 30.435 101.138 30.1963C101.344 29.9974 101.344 29.9974 101.508 29.7587C101.755 29.4404 101.96 29.2017 102.207 28.8437C103.644 26.7749 104.425 24.348 104.795 21.7223C105.329 17.8632 104.671 13.9644 103.316 10.6225C102.001 7.47954 99.865 4.85378 97.6877 3.26241C95.4284 1.63126 91.5258 -0.159034 87.7464 0.0398868C86.0622 0.15924 83.4741 0.000102626 81.7077 0.000102626C79.9002 0.000102626 63.7147 -0.0794658 63.3861 0.0398868L59.4424 5.01291C58.7441 5.88817 58.169 6.68385 57.4706 7.51932C57.0187 8.0763 55.7453 9.50853 55.4988 10.0655H60.0997Z"
          fill="#B5B4B2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.271 10.3042C43.0515 10.2644 44.0374 10.3838 44.8179 10.1451C45.1055 10.0257 45.2698 9.74725 45.4752 9.46876L47.2006 7.24084C47.6114 6.76343 47.94 6.36559 48.3097 5.8484C48.7616 5.21185 52.6231 0.51731 52.8696 0.0796833C49.7886 -0.119238 46.0914 0.0796833 42.9693 0.0796833C39.6419 0.0796833 36.2733 0.0796833 32.9459 0.0796833C26.2088 0.0796833 20.663 -0.636433 14.994 1.98933C-7.06587 12.0945 -5.91564 59.4377 26.1266 59.0001C32.9459 58.8808 40.751 58.841 47.406 58.7614C47.4881 57.5281 47.5292 48.2982 47.3649 47.5025C42.2299 47.224 24.1959 47.9003 21.2792 46.9057C15.8567 45.0756 13.1454 37.6758 12.9811 30.634C12.8168 23.1943 14.8297 15.7945 19.143 12.2537C22.1008 9.82682 25.1818 10.344 29.6184 10.344C31.5491 10.344 41.2851 10.1849 42.271 10.3042Z"
          fill="#1F488E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.1666 33.8165L48.7206 33.8563L48.7617 48.0593C48.7617 51.1226 48.7206 55.9365 48.8439 58.801L60.0586 58.7612V23.3135H37.0539C33.9319 27.3715 32.2887 29.9972 29.1666 33.8165Z"
          fill="#1F488E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.8029 10.1848H53.8557C54.4719 9.54825 55.2935 8.43429 55.8686 7.71817L60.8393 1.43226C61.1679 0.994638 61.6198 0.517227 61.8252 0.119385H54.2254C53.527 0.954853 52.8698 1.83011 52.2125 2.66557L46.297 10.1848H48.8029Z"
          fill="#B5B4B2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_73">
          <rect width="105" height="59" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AccordianArrow = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <path
          d="M12.449 15.6904C12.3157 15.6904 12.1864 15.6654 12.061 15.6154C11.9357 15.5654 11.8317 15.4987 11.749 15.4154L7.14902 10.8154C6.96569 10.632 6.87402 10.3987 6.87402 10.1154C6.87402 9.83205 6.96569 9.59871 7.14902 9.41538C7.33236 9.23205 7.56569 9.14038 7.84902 9.14038C8.13236 9.14038 8.36569 9.23205 8.54902 9.41538L12.449 13.3154L16.349 9.41538C16.5324 9.23205 16.7657 9.14038 17.049 9.14038C17.3324 9.14038 17.5657 9.23205 17.749 9.41538C17.9324 9.59871 18.024 9.83205 18.024 10.1154C18.024 10.3987 17.9324 10.632 17.749 10.8154L13.149 15.4154C13.049 15.5154 12.9407 15.5864 12.824 15.6284C12.7074 15.6704 12.5824 15.691 12.449 15.6904Z"
          fill="#131200"
        />
      </g>
    </svg>
  );
};
export const NextArrow = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6667 34.3333C26.8714 34.3333 34.3333 26.8714 34.3333 17.6667C34.3333 8.46192 26.8714 1 17.6667 1C8.46192 1 1 8.46192 1 17.6667C1 26.8714 8.46192 34.3333 17.6667 34.3333Z"
        fill="white"
        stroke="url(#paint0_linear_35_1138)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3333 24.3333L23.9999 17.6667L17.3333 11"
        stroke="#1F488E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6666 17.6667H24"
        stroke="#1F488E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_35_1138"
          x1="17.6667"
          y1="1"
          x2="17.6667"
          y2="34.3333"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.437725" stopColor="#1F488E" />
          <stop offset="1" stopColor="#727272" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const MoreIcon1 = () => {
  return (
    <svg
      className="group-hover:-translate-x-[2px] transition-all duration-300 ease-linear rotate-180"
      width="6"
      height="13"
      viewBox="0 0 6 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.272267 10.6741C-0.0887249 11.0861 -0.0887244 11.7682 0.260234 12.1803C0.621226 12.6066 1.18678 12.6066 1.53574 12.1803L5.73527 7.24956C5.90374 7.05062 6 6.78064 6 6.49645C6 6.21226 5.90374 5.94227 5.73527 5.74334L1.53574 0.81261C1.36727 0.599467 1.13865 0.5 0.910019 0.5C0.669358 0.5 0.44073 0.599467 0.260234 0.81261C-0.0887244 1.2389 -0.0887249 1.90675 0.272267 2.31883L3.82202 6.49645L0.272267 10.6741Z"
        fill="#1F52A9"
      />
    </svg>
  );
};
export const MoreIcon = () => {
  return (
    <svg
      className="group-hover:translate-x-[2px] transition-all duration-300 ease-linear"
      width="6"
      height="13"
      viewBox="0 0 6 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.272267 10.6741C-0.0887249 11.0861 -0.0887244 11.7682 0.260234 12.1803C0.621226 12.6066 1.18678 12.6066 1.53574 12.1803L5.73527 7.24956C5.90374 7.05062 6 6.78064 6 6.49645C6 6.21226 5.90374 5.94227 5.73527 5.74334L1.53574 0.81261C1.36727 0.599467 1.13865 0.5 0.910019 0.5C0.669358 0.5 0.44073 0.599467 0.260234 0.81261C-0.0887244 1.2389 -0.0887249 1.90675 0.272267 2.31883L3.82202 6.49645L0.272267 10.6741Z"
        fill="#1F52A9"
      />
    </svg>
  );
};
export const PrevArrow = () => {
  return (
    <svg
      className="'cursor-pointer"
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6667 34.3333C8.46196 34.3333 1.00004 26.8714 1.00004 17.6667C1.00004 8.46192 8.46196 1 17.6667 1C26.8715 1 34.3334 8.46192 34.3334 17.6667C34.3334 26.8714 26.8715 34.3333 17.6667 34.3333Z"
        fill="white"
      />
      <path
        d="M17.6667 34.3333C8.46196 34.3333 1.00004 26.8714 1.00004 17.6667C1.00004 8.46192 8.46196 1 17.6667 1C26.8715 1 34.3334 8.46192 34.3334 17.6667C34.3334 26.8714 26.8715 34.3333 17.6667 34.3333Z"
        stroke="#1F488E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6667 34.3333C8.46196 34.3333 1.00004 26.8714 1.00004 17.6667C1.00004 8.46192 8.46196 1 17.6667 1C26.8715 1 34.3334 8.46192 34.3334 17.6667C34.3334 26.8714 26.8715 34.3333 17.6667 34.3333Z"
        stroke="url(#paint0_linear_35_1144)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.0001 24.3333L11.3335 17.6667L18.0001 11"
        stroke="#1F488E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6667 17.6667H11.3334"
        stroke="#1F488E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_35_1144"
          x1="17.6667"
          y1="1"
          x2="17.6667"
          y2="34.3333"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.445069" stopColor="#1F488E" />
          <stop offset="1" stopColor="#727272" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const NextArrow1 = () => {
  return (
    <div className="group transition-all duration-300 ease-linear">
      <svg
        className="rotate-180"
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.30005 13.0005L1.30005 7.00049L7.30005 1.00049"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          className="group-hover:stroke-[#1F488E] transition-all duration-300 ease-linear"
          d="M7.30005 13.0005L1.30005 7.00049L7.30005 1.00049"
          stroke="#AAABAB"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className="group-hover:stroke-[#1F488E] transition-all duration-300 ease-linear"
          d="M13.3003 7.00049H1.30029"
          stroke="#AAABAB"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
export const BackToTop = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
        fill="white"
        stroke="url(#paint0_linear_2037_152)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22 16.3008L16 10.3008L10 16.3008" fill="white" />
      <path
        d="M22 16.3008L16 10.3008L10 16.3008"
        stroke="#1F488E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 22.3008V10.3008"
        stroke="#1F488E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2037_152"
          x1="16"
          y1="1"
          x2="16"
          y2="31"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.437725" stopColor="#1F488E" />
          <stop offset="1" stopColor="#727272" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const PrevArrow1 = () => {
  return (
    <svg
      className="group transition-all duration-300 ease-linear"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.30005 13.0005L1.30005 7.00049L7.30005 1.00049"
        fill="white"
        fillOpacity="0.5"
      />
      <path
        className="group-hover:stroke-[#1F488E] transition-all duration-300 ease-linear"
        d="M7.30005 13.0005L1.30005 7.00049L7.30005 1.00049"
        stroke="#AAABAB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="group-hover:stroke-[#1F488E] transition-all duration-300 ease-linear"
        d="M13.3003 7.00049H1.30029"
        stroke="#AAABAB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Watsaap = () => {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4806 0C6.56532 0 0.123734 6.20436 0.120943 13.8293C0.119082 16.2677 0.781475 18.6475 2.03742 20.7435L0 27.9098L7.61287 25.9868C9.7305 27.0946 12.0851 27.6724 14.475 27.6707H14.4806C22.3958 27.6707 28.8374 21.4655 28.8402 13.8405C28.842 10.1471 27.3498 6.67045 24.6379 4.05716C21.9269 1.44294 18.3219 0.000930328 14.4806 0ZM14.4806 25.3347H14.4759C12.3343 25.3347 10.2336 24.7802 8.40086 23.7327L7.96361 23.4833L3.44779 24.6239L4.6535 20.3816L4.36975 19.9472C3.17791 18.1294 2.54345 16.0029 2.54445 13.8293C2.54724 7.491 7.9022 2.33605 14.4852 2.33605C17.6725 2.33698 20.6691 3.53432 22.9233 5.70663C25.1775 7.87895 26.4176 10.7676 26.4157 13.8396C26.4129 20.1779 21.0589 25.3347 14.4796 25.3347H14.4806ZM21.0273 16.7245C20.6682 16.5524 18.9043 15.716 18.5749 15.5997C18.2465 15.4853 18.0074 15.4258 17.7683 15.7718C17.5302 16.1179 16.8417 16.8966 16.6333 17.1264C16.4231 17.3571 16.2138 17.385 15.8546 17.2129C15.4955 17.0399 14.3391 16.6752 12.9697 15.4974C11.9026 14.582 11.1825 13.4507 10.9732 13.1037C10.7639 12.7585 10.9509 12.5715 11.1304 12.3994C11.2914 12.2459 11.4895 11.9966 11.6682 11.7947C11.8468 11.5928 11.9063 11.4486 12.0273 11.2179C12.1464 10.9881 12.0868 10.7853 11.9966 10.6132C11.9063 10.4392 11.19 8.73857 10.8895 8.04734C10.5992 7.37378 10.3034 7.46402 10.0829 7.45286C9.87357 7.44355 9.6354 7.44076 9.39445 7.44076C9.15722 7.44076 8.76741 7.52728 8.43807 7.87336C8.10967 8.21945 7.18213 9.05488 7.18213 10.7555C7.18213 12.4571 8.46784 14.1 8.6474 14.3308C8.82695 14.5606 11.1779 18.0521 14.7773 19.5499C15.6332 19.9044 16.3012 20.1174 16.8231 20.2774C17.6827 20.5407 18.4651 20.5026 19.0829 20.4142C19.7713 20.3146 21.2059 19.5787 21.5036 18.7722C21.8032 17.9656 21.8032 17.2734 21.7139 17.1292C21.6264 16.985 21.3864 16.8985 21.0273 16.7245Z"
        fill="white"
      />
    </svg>
  );
};
export const Instragram = () => {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9386 0C11.1484 0 10.6739 0.0158156 9.18541 0.0837295C7.69968 0.151643 6.68469 0.387947 5.79716 0.733098C4.86683 1.0829 4.02302 1.6318 3.32528 2.34257C2.61564 3.03951 2.06641 3.88272 1.71581 4.81352C1.37252 5.70105 1.13529 6.71697 1.06737 8.2027C1.00039 9.6903 0.983643 10.1638 0.983643 13.9549C0.983643 17.746 0.999458 18.2195 1.06737 19.7081C1.13529 21.1938 1.37159 22.2088 1.71674 23.0963C2.06654 24.0266 2.61544 24.8705 3.32621 25.5682C4.02317 26.2778 4.86637 26.827 5.79716 27.1777C6.68469 27.5219 7.69968 27.7582 9.18541 27.8261C10.6739 27.894 11.1484 27.9098 14.9386 27.9098C18.7287 27.9098 19.2032 27.894 20.6917 27.8261C22.1774 27.7582 23.1924 27.5219 24.08 27.1767C25.0103 26.8269 25.8541 26.278 26.5518 25.5673C27.2615 24.8703 27.8107 24.0271 28.1613 23.0963C28.5055 22.2088 28.7418 21.1938 28.8097 19.7081C28.8777 18.2195 28.8935 17.7451 28.8935 13.9549C28.8935 10.1648 28.8777 9.6903 28.8097 8.20177C28.7418 6.71604 28.5055 5.70105 28.1604 4.81352C27.81 3.88232 27.2608 3.03875 26.5509 2.34164C25.854 1.632 25.0108 1.08277 24.08 0.732168C23.1924 0.388877 22.1765 0.151643 20.6908 0.0837295C19.2032 0.0167459 18.7296 0 14.9386 0ZM14.9386 2.51468C18.6645 2.51468 19.1064 2.52863 20.5782 2.59561C21.9383 2.65795 22.677 2.88402 23.1692 3.07659C23.8204 3.32871 24.2856 3.632 24.774 4.11949C25.2624 4.60791 25.5648 5.07308 25.8169 5.72431C26.0085 6.21645 26.2355 6.95513 26.2979 8.31527C26.3648 9.78705 26.3788 10.229 26.3788 13.9549C26.3788 17.6809 26.3648 18.1228 26.2979 19.5946C26.2355 20.9547 26.0095 21.6934 25.8169 22.1855C25.5935 22.7917 25.2372 23.3401 24.774 23.7903C24.3238 24.2536 23.7754 24.61 23.1692 24.8332C22.677 25.0249 21.9383 25.2519 20.5782 25.3142C19.1064 25.3812 18.6655 25.3952 14.9386 25.3952C11.2117 25.3952 10.7707 25.3812 9.29891 25.3142C7.93877 25.2519 7.20009 25.0258 6.70795 24.8332C6.1018 24.6099 5.55342 24.2535 5.10313 23.7903C4.64 23.34 4.28363 22.7917 4.06024 22.1855C3.86859 21.6934 3.64159 20.9547 3.57926 19.5946C3.51227 18.1228 3.49832 17.6809 3.49832 13.9549C3.49832 10.229 3.51227 9.78705 3.57926 8.31527C3.64159 6.95513 3.86766 6.21645 4.06024 5.72431C4.31236 5.07308 4.61564 4.60791 5.10313 4.11949C5.55336 3.65623 6.10176 3.29985 6.70795 3.07659C7.20009 2.88495 7.93877 2.65795 9.29891 2.59561C10.7707 2.52863 11.2126 2.51468 14.9386 2.51468Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9386 18.6113C14.3271 18.6113 13.7216 18.4908 13.1567 18.2568C12.5918 18.0228 12.0785 17.6798 11.6461 17.2475C11.2137 16.8151 10.8707 16.3018 10.6367 15.7369C10.4027 15.1719 10.2823 14.5664 10.2823 13.955C10.2823 13.3435 10.4027 12.738 10.6367 12.1731C10.8707 11.6082 11.2137 11.0949 11.6461 10.6625C12.0785 10.2301 12.5918 9.88712 13.1567 9.65312C13.7216 9.41912 14.3271 9.29868 14.9386 9.29868C16.1735 9.29868 17.3579 9.78925 18.2311 10.6625C19.1043 11.5357 19.5949 12.72 19.5949 13.955C19.5949 15.1899 19.1043 16.3742 18.2311 17.2475C17.3579 18.1207 16.1735 18.6113 14.9386 18.6113ZM14.9386 6.78214C13.0362 6.78214 11.2118 7.53785 9.86664 8.88301C8.52147 10.2282 7.76577 12.0526 7.76577 13.955C7.76577 15.8573 8.52147 17.6818 9.86664 19.0269C11.2118 20.3721 13.0362 21.1278 14.9386 21.1278C16.8409 21.1278 18.6654 20.3721 20.0105 19.0269C21.3557 17.6818 22.1114 15.8573 22.1114 13.955C22.1114 12.0526 21.3557 10.2282 20.0105 8.88301C18.6654 7.53785 16.8409 6.78214 14.9386 6.78214ZM24.1981 6.6519C24.1981 7.10158 24.0195 7.53284 23.7015 7.85081C23.3836 8.16878 22.9523 8.34742 22.5026 8.34742C22.0529 8.34742 21.6217 8.16878 21.3037 7.85081C20.9857 7.53284 20.8071 7.10158 20.8071 6.6519C20.8071 6.20222 20.9857 5.77095 21.3037 5.45298C21.6217 5.13501 22.0529 4.95637 22.5026 4.95637C22.9523 4.95637 23.3836 5.13501 23.7015 5.45298C24.0195 5.77095 24.1981 6.20222 24.1981 6.6519Z"
        fill="white"
      />
    </svg>
  );
};
export const Facebook = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.9467 14.0396C27.9467 6.2853 21.6996 0 13.9918 0C6.28402 0 0.0368652 6.2853 0.0368652 14.0396C0.0368652 21.0487 5.13878 26.8567 11.8111 27.9098V18.0986H8.26841V14.0386H11.8111V10.9462C11.8111 7.42774 13.8941 5.48335 17.0823 5.48335C18.6081 5.48335 20.2064 5.7578 20.2064 5.7578V9.21304H18.4453C16.7121 9.21304 16.1725 10.2959 16.1725 11.4067V14.0396H20.0426L19.424 18.0977H16.1725V27.9098C22.8448 26.8567 27.9467 21.0487 27.9467 14.0396Z"
        fill="white"
      />
    </svg>
  );
};
export const LinkedIn = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.9098 2.05219V25.8576C27.9098 26.4019 27.6936 26.9239 27.3088 27.3088C26.9239 27.6936 26.4019 27.9098 25.8576 27.9098H2.05219C1.50792 27.9098 0.985935 27.6936 0.601074 27.3088C0.216213 26.9239 0 26.4019 0 25.8576L0 2.05219C0 1.50792 0.216213 0.985935 0.601074 0.601074C0.985935 0.216213 1.50792 0 2.05219 0L25.8576 0C26.4019 0 26.9239 0.216213 27.3088 0.601074C27.6936 0.985935 27.9098 1.50792 27.9098 2.05219ZM8.20878 10.6714H4.10439V23.8054H8.20878V10.6714ZM8.57817 6.15658C8.58033 5.84612 8.52132 5.53827 8.40451 5.25061C8.2877 4.96295 8.11537 4.70112 7.89736 4.48007C7.67935 4.25901 7.41994 4.08306 7.13393 3.96226C6.84792 3.84147 6.54092 3.77819 6.23046 3.77604H6.15658C5.52522 3.77604 4.91972 4.02684 4.47328 4.47328C4.02684 4.91972 3.77604 5.52522 3.77604 6.15658C3.77604 6.78794 4.02684 7.39344 4.47328 7.83988C4.91972 8.28632 5.52522 8.53713 6.15658 8.53713C6.46707 8.54476 6.77601 8.49115 7.06577 8.37935C7.35553 8.26754 7.62042 8.09974 7.8453 7.88553C8.07019 7.67132 8.25066 7.4149 8.37641 7.13091C8.50216 6.84693 8.57071 6.54095 8.57817 6.23046V6.15658ZM23.8054 15.8265C23.8054 11.8781 21.2936 10.3431 18.7981 10.3431C17.981 10.3021 17.1675 10.4762 16.4387 10.8478C15.7099 11.2194 15.0912 11.7756 14.6445 12.4609H14.5295V10.6714H10.6714V23.8054H14.7758V16.8198C14.7165 16.1043 14.9418 15.3944 15.4029 14.8441C15.864 14.2939 16.5236 13.9478 17.2384 13.881H17.3944C18.6996 13.881 19.6682 14.7019 19.6682 16.7705V23.8054H23.7726L23.8054 15.8265Z"
        fill="white"
      />
    </svg>
  );
};
export const CallIcon = () => {
  return (
    <svg
      width="21"
      height="23"
      viewBox="0 0 21 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.93315 3.4257L6.58044 3.09235C7.33032 2.94036 8.13689 2.9769 8.8496 3.19515C9.56231 3.4134 10.1325 3.79844 10.4536 4.2784L11.4787 5.81046C11.7549 6.22319 11.8318 6.68366 11.6987 7.12726C11.5656 7.57086 11.2291 7.97533 10.7364 8.2839L8.94521 9.40595C8.92378 9.42025 8.90571 9.43666 8.89162 9.45462C8.70407 9.71196 8.98887 10.3993 9.881 11.438C10.8872 12.6087 11.6642 13.0714 12.0245 13.0001L14.3753 12.5167C15.0192 12.3847 15.7084 12.3912 16.3463 12.5355C16.9843 12.6798 17.5391 12.9547 17.9329 13.3214L19.3897 14.6768C19.847 15.1024 20.0589 15.6251 19.9859 16.1477C19.9129 16.6703 19.56 17.1573 18.9927 17.5183L17.7394 18.315C17.3036 18.5923 16.7743 18.7947 16.1968 18.9049C15.6193 19.0151 15.0107 19.0298 14.423 18.9477C10.9329 18.4597 7.806 16.5716 5.01551 13.3248C2.22404 10.076 1.35375 7.30919 2.4751 5.03377C2.66281 4.65282 2.98425 4.30783 3.41225 4.02793C3.84026 3.74804 4.36126 3.54148 4.93315 3.4257ZM5.36482 4.38307C5.02167 4.45251 4.70845 4.57642 4.45161 4.74433C4.19477 4.91224 4.00187 5.11922 3.8892 5.34778C2.92265 7.30853 3.70561 9.7993 6.30556 12.8248C8.90353 15.8482 11.7198 17.5483 14.7276 17.9683C15.0803 18.0175 15.4454 18.0086 15.7919 17.9424C16.1384 17.8763 16.4559 17.7548 16.7173 17.5883L17.9696 16.7923C18.2752 16.5979 18.4653 16.3357 18.5047 16.0543C18.5442 15.7729 18.4302 15.4914 18.184 15.2622L16.7272 13.9061C16.5152 13.7087 16.2165 13.5607 15.8731 13.483C15.5296 13.4053 15.1586 13.4017 14.812 13.4728L12.4551 13.9575C11.1512 14.2181 9.92466 13.4881 8.59293 11.9374C7.46463 10.6253 7.07364 9.67729 7.55592 9.01526C7.64987 8.88637 7.7749 8.77281 7.93103 8.67458L9.72222 7.55254C9.98761 7.38638 10.1689 7.16857 10.2406 6.92966C10.3123 6.69076 10.2709 6.44276 10.1221 6.22048L9.09605 4.68908C8.92314 4.43058 8.61608 4.2232 8.23223 4.10566C7.84838 3.98813 7.41397 3.96848 7.01013 4.05039L5.36482 4.38307Z"
        fill="white"
      />
    </svg>
  );
};
export const EmailIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_945_2278)">
        <path
          d="M4.55 5.86875L10.3895 11.3906C10.449 11.4469 10.551 11.4469 10.6105 11.3906L16.45 5.86875M3.02 3H17.98C18.541 3 19 3.50625 19 4.125V15.75C19 16.9875 18.082 18 16.96 18H4.04C2.918 18 2 16.9875 2 15.75V4.125C2 3.50625 2.459 3 3.02 3Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_945_2278">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.412842 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const LocationIcon = () => {
  return (
    <svg
      className="h-[24px] w-[22px] scale-125"
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2575 20.5C16.1539 15.2289 19.1022 11.2778 19.1022 8.64651C19.1022 4.6996 15.1423 1.5 10.2575 1.5C5.37273 1.5 1.41284 4.6996 1.41284 8.64651C1.41284 11.2778 4.36106 15.2289 10.2575 20.5Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2579 11.5684C12.2932 11.5684 13.9432 10.2426 13.9432 8.6072C13.9432 6.97177 12.2932 5.646 10.2579 5.646C8.22259 5.646 6.57263 6.97177 6.57263 8.6072C6.57263 10.2426 8.22259 11.5684 10.2579 11.5684Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
